/* eslint-disable */

import React from 'react';
import {fetchContent} from "./counterSlice";


import $ from "jquery";
import { rxhtmltag4jQuery } from "./rxhtmltag";
rxhtmltag4jQuery();

const handleDownloadCLick = (e,dartSelectors)=>{
    e.preventDefault()
    // console.log(dartSelectors);

$("#tg_toc_id [href*='.dita']").each((index,element)=>{
    let topicFile=$(element).attr("href");


    dartSelectors.iDB.read(topicFile).then((value)=>{
        if(value!==null){
            console.log(index,"Cached",topicFile);
        //   console.log("Cached in iDB - "+topicFile);
        }else{
            setTimeout(() => {
                // console.log("downloading...",topicFile);
                console.log(index,"Downloading",topicFile);
                dartSelectors.dispatch(fetchContent({
                    guideline:dartSelectors.ditapath,
                    topicFile,
                dartSelectors}));
            }, 500);
        }
      })

});

}

export const Download = (props)=>{

        return(
    <a href="#/" title="Download .ditafiles...limit use for now." onClick={(e)=>handleDownloadCLick(e,props.dartSelectors)}>D</a>
    )
}